import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const ColorPicker = ({ currentColor, onColorChange }) => {
  const { t } = useLanguage();

  const colors = [
    { name: t('colors.purple'), value: '#5D5CDE' },
    { name: t('colors.deepPurple'), value: '#5E17EB' },
    { name: t('colors.yellow'), value: '#FFDE59' },
    { name: t('colors.blue'), value: '#61DAFB' },
    { name: t('colors.green'), value: '#88EFDD' },
    { name: t('colors.lightPurple'), value: '#D4B3FF' },
    { name: t('colors.orange'), value: '#FFB677' },
    { name: t('colors.teal'), value: '#20B2AA' },
    { name: t('colors.pink'), value: '#FFAAD4' },
    { name: t('colors.red'), value: '#FF8E8E' },
    { name: t('colors.mintGreen'), value: '#98FB98' },
    { name: t('colors.skyBlue'), value: '#87CEEB' },
    { name: t('colors.golden'), value: '#FFD700' },
    { name: t('colors.coral'), value: '#FF7F50' },
    { name: t('colors.crimson'), value: '#DC143C' },
    { name: t('colors.indigo'), value: '#4B0082' },
    { name: t('colors.lavender'), value: '#E6E6FA' },
    { name: t('colors.hotPink'), value: '#FF1493' },
    { name: t('colors.emerald'), value: '#50C878' },
    { name: t('colors.turquoise'), value: '#40E0D0' }
  ];

  return (
    <div className="space-y-4">
      {/* 顏色網格 */}
      <div className="grid grid-cols-5 gap-3 p-4 bg-gray-50 dark:bg-gray-700 rounded-xl">
        {colors.map((color, index) => (
          <button
            key={index}
            onClick={() => onColorChange(color.value)}
            className={`w-12 h-12 rounded-xl transition-all duration-200 hover:scale-110 border-3 shadow-md hover:shadow-lg ${
              currentColor === color.value
                ? 'border-gray-800 dark:border-white shadow-xl scale-110 ring-4 ring-gray-300 dark:ring-gray-600'
                : 'border-gray-300 dark:border-gray-500 hover:border-gray-400 dark:hover:border-gray-400'
            }`}
            style={{ backgroundColor: color.value }}
            title={color.name}
          />
        ))}
      </div>

      {/* 當前選中的顏色顯示 */}
      <div className="flex items-center justify-center space-x-4 p-3 bg-gray-100 dark:bg-gray-600 rounded-xl">
        <div
          className="w-8 h-8 rounded-full border-3 border-gray-300 dark:border-gray-500 shadow-md"
          style={{ backgroundColor: currentColor }}
        />
        <div className="text-center">
          <p className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-1">
            {t('currentColor') || '當前顏色'}
          </p>
          <p className="text-xs text-gray-600 dark:text-gray-300">
            {colors.find(c => c.value === currentColor)?.name || '自訂顏色'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ColorPicker;